<div class="cmms-filter-list-container">
	<au-search-input
		class="m-b-sxs filters-search"
		[placeholder]="'filters_filter_by' | translate"
		(click)="$event.stopPropagation()"
		(searchTextChanged)="searchText = $event"
		subscriptSizingMode="dynamic"
	></au-search-input>
	<div class="cmms-filters-list nice-scroll visible-scroll colored-scroll-track">
		@if (availableFilters.length) {
			@if (availableFilters | auQuickSearchName: searchText; as searchResults) {
				@for (filter of searchResults; track filter) {
					<div class="filter-item" (click)="selectFilter(filter)">
						<mat-icon
							class="cmms-filter-icon"
							[svgIcon]="filterTypeIcons[filter.type]"
							[ngClass]="filter.type + '-icon'"
						></mat-icon>
						<span class="cmms-filter-name">{{ filter.name | translate }}</span>
					</div>
				}
				@if (!searchResults.length) {
					<div class="no-results">
						<div class="no-data p-l-sm m-t-sxs m-b-sxs">
							{{ 'filters_no_results' | translate }}
						</div>
					</div>
				}
			}
		} @else {
			<div class="no-data p-l-sm m-t-sxs m-b-sxs">
				{{ 'filters_all_selected' | translate }}
			</div>
		}
	</div>
</div>
